const e = "_imageOverlay_pwkhj_1", a = "_fullWidthImageWrapper_pwkhj_10", l = "_enableImageOverlay_pwkhj_18", r = "_image_pwkhj_1", g = {
  imageOverlay: e,
  fullWidthImageWrapper: a,
  enableImageOverlay: l,
  image: r
};
export {
  g as default,
  l as enableImageOverlay,
  a as fullWidthImageWrapper,
  r as image,
  e as imageOverlay
};
